import { render, staticRenderFns } from "./match-list.vue?vue&type=template&id=42f65ab7&scoped=true"
import script from "./match-list.vue?vue&type=script&lang=js"
export * from "./match-list.vue?vue&type=script&lang=js"
import style0 from "./match-list.vue?vue&type=style&index=0&id=42f65ab7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42f65ab7",
  null
  
)

export default component.exports